export const GET_CRISIS_LIST = "GET_CRISIS_LIST";
export const SET_CRISIS_DETAIL = "SET_CRISIS_DETAIL";
export const CRISIS_RECORDS_SET = "CRISIS_RECORDS_SET";
export const CRISIS_LOADING = "CRISIS_LOADING";
export const CRISIS_PATCH = "CRISIS_PATCH";
